import { object, string } from "yup";

export const contactValidationSchema = (requiredText, intl) => {
  return object().shape({
    description: string().required(requiredText),
    email: string().required(requiredText),
    name: string().required(requiredText),
    telephone: string().required(requiredText),
  });
};
